import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fetchCheckinsStat,
  fetchDashboardFeatureGrouping,
  fetchDashboardFeatureMapping,
  fetchDashboardFeatures,
  fetchDashboardFeedbacks,
  fetchDashboardMenus,
  fetchFeaturesDocumentation,
  fetchTransferedPT,
  fetchUserMappedFeature,
} from "./featuresApiS";

export const fetchDashboardMenusdata = createAsyncThunk(
  "features/fetchDashboardMenusdata",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const reponse = await fetchDashboardMenus(filters, token);
    return reponse;
  }
);

export const fetchDashboardFeaturesdata = createAsyncThunk(
  "features/fetchDashboardFeaturesdata",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const reponse = await fetchDashboardFeatures(filters, token);
    return reponse;
  }
);

export const fetchDashboardFeatureMappingData = createAsyncThunk(
  "features/fetchDashboardFeatureMappingData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const reponse = await fetchDashboardFeatureMapping(filters, token);
    return reponse;
  }
);

export const fetchUserMappedFeatureData = createAsyncThunk(
  "features/fetchUserMappedFeatureData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const reponse = await fetchUserMappedFeature(filters, token);
    return reponse;
  }
);

export const fetchUserMappedFeatureDataV1 = createAsyncThunk(
  "features/fetchUserMappedFeatureDataV1",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const reponse = await fetchUserMappedFeature(filters, token);
    return reponse;
  }
);

export const fetchTransferedPTData = createAsyncThunk(
  "features/fetchTransferedPTData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const reponse = await fetchTransferedPT(filters, token);
    return reponse;
  }
);

export const fetchFeaturesDocumentationData = createAsyncThunk(
  "features/fetchFeaturesDocumentationData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const reponse = await fetchFeaturesDocumentation(filters, token);
    return reponse;
  }
);

export const fetchDashboardFeedbacksData = createAsyncThunk(
  "features/fetchDashboardFeedbacksData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const reponse = await fetchDashboardFeedbacks(filters, token);
    return reponse;
  }
);

export const fetchDashboardFeatureGroupingdata = createAsyncThunk(
  "features/fetchDashboardFeatureGroupingdata",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const reponse = await fetchDashboardFeatureGrouping(filters, token);
    return reponse;
  }
);

export const fetchCheckinsStatData = createAsyncThunk(
  "features/fetchCheckinsStatData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const reponse = await fetchCheckinsStat(filters, token);
    return reponse;
  }
);

const featuresSlice = createSlice({
  name: "features",
  initialState: {
    dashboardMenus: null,
    dashboardMenusLoading: false,
    dashboardMenusError: null,

    dashboardFeatures: null,
    dashboardFeaturesLoading: false,
    dashboardFeaturesError: null,

    mappedPages: null,
    mappedPagesLoading: false,
    mappedPagesError: null,

    userMappedFeatures: null,
    userMappedFeaturesLoading: false,
    userMappedFeaturesError: null,

    userMappedFeaturesV1: null,
    userMappedFeaturesV1Loading: false,
    userMappedFeaturesV1Error: null,

    transferedPT: null,
    transferedPTLoading: false,
    transferedPTError: null,

    featureDoc: null,
    featureDocLoading: false,
    featureDocError: null,

    dashFeedbacks: null,
    dashFeedbacksLoading: false,
    dashFeedbacksError: null,

    dashFeatureGrouping: null,
    dashFeatureGroupingLoading: false,
    dashFeatureGroupingError: null,

    checkinsStat: null,
    checkinsStatLoading: false,
    checkinsStatError: null,
  },
  reducers: {
    clearFeatureDoc: (state) => {
      state.featureDoc = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardMenusdata.pending, (state) => {
        state.dashboardMenusLoading = true;
      })
      .addCase(fetchDashboardMenusdata.fulfilled, (state, action) => {
        state.dashboardMenusLoading = false;
        state.dashboardMenus = action.payload;
      })
      .addCase(fetchDashboardMenusdata.rejected, (state, action) => {
        state.dashboardMenusLoading = false;
        state.dashboardMenusError = action.error.message;
      })

      .addCase(fetchDashboardFeaturesdata.pending, (state) => {
        state.dashboardFeaturesLoading = true;
      })
      .addCase(fetchDashboardFeaturesdata.fulfilled, (state, action) => {
        state.dashboardFeaturesLoading = false;
        state.dashboardFeatures = action.payload;
      })
      .addCase(fetchDashboardFeaturesdata.rejected, (state, action) => {
        state.dashboardFeaturesLoading = false;
        state.dashboardFeaturesError = action.error.message;
      })

      .addCase(fetchDashboardFeatureMappingData.pending, (state) => {
        state.mappedPagesLoading = true;
      })
      .addCase(fetchDashboardFeatureMappingData.fulfilled, (state, action) => {
        state.mappedPagesLoading = false;
        state.mappedPages = action.payload;
      })
      .addCase(fetchDashboardFeatureMappingData.rejected, (state, action) => {
        state.mappedPagesLoading = false;
        state.mappedPagesError = action.error.message;
      })

      .addCase(fetchUserMappedFeatureData.pending, (state) => {
        state.userMappedFeaturesLoading = true;
      })
      .addCase(fetchUserMappedFeatureData.fulfilled, (state, action) => {
        state.userMappedFeaturesLoading = false;
        state.userMappedFeatures = action.payload;
      })
      .addCase(fetchUserMappedFeatureData.rejected, (state, action) => {
        state.userMappedFeaturesLoading = false;
        state.userMappedFeaturesError = action.error.message;
      })

      .addCase(fetchUserMappedFeatureDataV1.pending, (state) => {
        state.userMappedFeaturesV1Loading = true;
      })
      .addCase(fetchUserMappedFeatureDataV1.fulfilled, (state, action) => {
        state.userMappedFeaturesV1Loading = false;
        state.userMappedFeaturesV1 = action.payload;
      })
      .addCase(fetchUserMappedFeatureDataV1.rejected, (state, action) => {
        state.userMappedFeaturesV1Loading = false;
        state.userMappedFeaturesV1Error = action.error.message;
      })

      .addCase(fetchTransferedPTData.pending, (state) => {
        state.transferedPTLoading = true;
      })
      .addCase(fetchTransferedPTData.fulfilled, (state, action) => {
        state.transferedPTLoading = false;
        state.transferedPT = action.payload;
      })
      .addCase(fetchTransferedPTData.rejected, (state, action) => {
        state.transferedPTLoading = false;
        state.transferedPTError = action.error.message;
      })

      .addCase(fetchFeaturesDocumentationData.pending, (state) => {
        state.featureDocLoading = true;
        state.featureDoc = null;
      })
      .addCase(fetchFeaturesDocumentationData.fulfilled, (state, action) => {
        state.featureDocLoading = false;
        state.featureDoc = action.payload;
      })
      .addCase(fetchFeaturesDocumentationData.rejected, (state, action) => {
        state.featureDocLoading = false;
        state.featureDocError = action.error.message;
      })

      .addCase(fetchDashboardFeedbacksData.pending, (state) => {
        state.dashFeedbacksLoading = true;
      })
      .addCase(fetchDashboardFeedbacksData.fulfilled, (state, action) => {
        state.dashFeedbacksLoading = false;
        state.dashFeedbacks = action.payload;
      })
      .addCase(fetchDashboardFeedbacksData.rejected, (state, action) => {
        state.dashFeedbacksLoading = false;
        state.dashFeedbacksError = action.error.message;
      })

      .addCase(fetchDashboardFeatureGroupingdata.pending, (state) => {
        state.dashFeatureGroupingLoading = true;
      })
      .addCase(fetchDashboardFeatureGroupingdata.fulfilled, (state, action) => {
        state.dashFeatureGroupingLoading = false;
        state.dashFeatureGrouping = action.payload;
      })
      .addCase(fetchDashboardFeatureGroupingdata.rejected, (state, action) => {
        state.dashFeatureGroupingLoading = false;
        state.dashFeatureGroupingError = action.error.message;
      })

      .addCase(fetchCheckinsStatData.pending, (state) => {
        state.checkinsStatLoading = true;
      })
      .addCase(fetchCheckinsStatData.fulfilled, (state, action) => {
        state.checkinsStatLoading = false;
        state.checkinsStat = action.payload;
      })
      .addCase(fetchCheckinsStatData.rejected, (state, action) => {
        state.checkinsStatLoading = false;
        state.checkinsStatError = action.error.message;
      });
  },
});

export const {clearFeatureDoc} = featuresSlice.actions

export default featuresSlice.reducer;
